import {Request} from "../core/request";
import {AuthHeader} from "../core/token";
import {
    createHomeworkBankRequest, createHomeworkBankTempRequest, getHomeworkBankTempsRequest, getHomeworkBankTempsResponse,
    getMyHomeworkBankRequest, homeworkTemp,
    HomeworkTempBank,
    parserHomeworkQuestionWithDocxRequest, parserHomeworkQuestionWithDocxResponse
} from "./types";


export async function getMyHomeworkBank(req: getMyHomeworkBankRequest): Promise<{
    total: number,
    data: HomeworkTempBank[]
}> {
    const resp = await Request.get(`/teacher/homeworkBank/`, {
        headers: AuthHeader(),
        params: req,
    });
    return resp.data;
}

export async function getHomeworkBank(bankID: number): Promise<HomeworkTempBank> {
    const resp = await Request.get(`/teacher/homeworkBank/${bankID}`, {
        headers: AuthHeader(),
    });
    return resp.data.data;
}

export async function createHomeworkBank(req: createHomeworkBankRequest): Promise<void> {
    return await Request.post(`/teacher/homeworkBank/`, req, {
        headers: AuthHeader(),
    });
}

export async function updateHomeworkBank(bandID: number, req: createHomeworkBankRequest): Promise<void> {
    return await Request.put(`/teacher/homeworkBank/${bandID}`, req, {
        headers: AuthHeader(),
    });
}

export async function deleteHomeworkBank(bandID: number): Promise<void> {
    return await Request.delete(`/teacher/homeworkBank/${bandID}`, {
        headers: AuthHeader(),
    });
}


export async function parserHomeworkQuestionWithDocx(req: parserHomeworkQuestionWithDocxRequest): Promise<parserHomeworkQuestionWithDocxResponse> {
    const formData = new FormData();

    formData.append('question_file', req.questionFile)
    if (req.answerFile) {
        formData.append('answer_file', req.answerFile);
    }

    const response = await Request.post(`/teacher/homeworkBank/parser_docx`, formData, {
        headers: AuthHeader(),
    })
    return response.data;
}

export async function getHomeworkBankTemps(bankId: number, req: getHomeworkBankTempsRequest): Promise<getHomeworkBankTempsResponse> {
    const response = await Request.get(`/teacher/homeworkBank/${bankId}/temps`, {
        params: req,
        headers: AuthHeader(),
    })
    return response.data;
}

/** 同一作业库内是否已有同名模板（不含首尾空格，精确匹配 name 字段） */
export async function checkHomeworkBankTempNameExists(bankId: number, name: string): Promise<{ exists: boolean }> {
    const response = await Request.get(`/teacher/homeworkBank/${bankId}/temps/name_exists`, {
        params: { name },
        headers: AuthHeader(),
    });
    return response.data;
}

export async function getHomeworkBankTemp(bankId: number, tempId: number): Promise<homeworkTemp> {
    const response = await Request.get(`/teacher/homeworkBank/${bankId}/temps/${tempId}`, {
        headers: AuthHeader(),
    })
    return response.data;
}

export async function deleteHomeworkBankTemp(bankId: number, tempId: number): Promise<void> {
    return await Request.delete(`/teacher/homeworkBank/${bankId}/temps/${tempId}`, {
        headers: AuthHeader(),
    })
}

export async function createHomeworkBankTemp(bankId: number, req: createHomeworkBankTempRequest): Promise<void> {
    return await Request.post(`/teacher/homeworkBank/${bankId}/temps`, req, {
        headers: AuthHeader(),
    })
}

export async function updateHomeworkBankTemp(bankId: number, tempId: number, req: createHomeworkBankTempRequest): Promise<void> {
    return await Request.put(`/teacher/homeworkBank/${bankId}/temps/${tempId}`, req, {
        headers: AuthHeader(),
    })
}

export async function migrateHomeworkBankTemp(
    bankId: number,
    tempId: number,
    targetBankId: number,
): Promise<void> {
    await Request.post(
        `/teacher/homeworkBank/${bankId}/temps/${tempId}/migrate`,
        { target_bank_id: targetBankId },
        { headers: AuthHeader() },
    );
}